import { render, staticRenderFns } from "./base-loading-indicator.vue?vue&type=template&id=b36120ae&scoped=true"
import script from "./base-loading-indicator.vue?vue&type=script&lang=ts"
export * from "./base-loading-indicator.vue?vue&type=script&lang=ts"
import style0 from "./base-loading-indicator.vue?vue&type=style&index=0&id=b36120ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36120ae",
  null
  
)

export default component.exports